import styled from 'styled-components';

export const InputBoxDiv = styled.div``;
